<button *ngIf="isDisplay" class="btn btn-copy ml-1" type="button" ngxClipboard (cbOnSuccess)="isCopied = true" [cbContent]="value" 
  [ngClass]="(value === contentClipboard) && 'btn-active'" (click)="getDataClipboard()">
  <img src="./assets/images/icon/copy.svg" width="15" height="15">
</button>